import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "../../components/Pagination";
import Search from "../Search";
import MySous from "./mysous";
import InPayement from "../inpayement";
import { Person, PhoneFill } from "react-bootstrap-icons";

export default function MySouscription() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [inpayment, setinpayment] = useState(false);
    const [addstate, setAddstate] = useState(false);

    const [fetching, setFetching] = useState(false);


    const [elementsList, setElementsList] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    const [nbelement, setNbelement] = useState(0);
    const [page, setPage] = useState(0);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');

    const [abonnement, setabonnement] = useState('');
    const [abonnementsList, setabonnementsList] = useState([]);
    const [numtel, setnumtel] = useState('');
    const [noms, setnoms] = useState('');

    const [codetransaction, setcodetransaction] = useState('');
    const [idop, setidop] = useState('');
    const [valtoken, setvaltoken] = useState('');
    let timerID = null;
    let intervId = null;
    const [textloader, settextloader] = useState('Payement en cours: En attente de confirmation.');


    const showErrorMessage = (msg) => {
            toast.error(msg, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        };
    
        // const showWarningMessage = (msg) => {
        //     toast.warning(msg, {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         theme: "colored",
        //     });
        // }
    
        const showSuccesMessage = (msg) => {
            toast.success(msg, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        };

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptionstakenout?limit=${config.app.limit}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        setElementsList(clientarray);
                        setNbpage(data?.body?.pages);
                        setNbelement(data?.body?.length);
                        setnoms(user?.nom);
                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const autoSearchElement = async (c) => {
        setPage(0);
        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);


            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptionstakenout?crit=${c}&coderevendeur=${user?.codeutilisateur}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // console.log("resonse jsondecode", data);
                            let clientarray = [];
                            clientarray = data?.body?.data;

                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            // setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }

    const getAbonnementList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            if (element?.abrevtabonnement === "APARTS" || element?.abrevtabonnement === "AVPNS") {
                                clientarraydata.push({ label: element.lib+ " - "+ element?.prix + " XAF - "+element?.duree+" ("+element.prof+")", value: element.code, pduree: element.duree, pprix: element?.prix, pack: element.prof });
                            }
                        });


                        setabonnementsList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    // console.log('user: ', user?.codeutilisateur);

    // comportements
    useEffect(() => {
        getElementsList(page);
        getAbonnementList();
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchElement(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);

    const handlePay = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("codeabonnement", abonnement["value"]);
        urlencoded.append("pack", abonnement["pack"]);
        urlencoded.append("montant", abonnement["pprix"]);
        urlencoded.append("nom", noms);
        urlencoded.append("numtel", "+237" + numtel);
        urlencoded.append("descr", "Achat de l'abonnement "+ abonnement["pack"] +" publicitaire Yconnekt " + abonnement["pduree"] + " à " + abonnement["pprix"] + " XAF");
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);
        urlencoded.append("etatdef", "Initié");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg);
                        }
                    } else {
                        setinpayment(true);
                        setcodetransaction(data?.body?.data?.creertransaction);
                        setidop(data?.body?.data?.idop);

                        let codetr = data?.body?.data?.creertransaction;
                        let idopin = data?.body?.data?.idop;

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

                        var urlencoded = new URLSearchParams();
                        urlencoded.append("username", config.campay.campayuser);
                        urlencoded.append("password", config.campay.campaypass);

                        var requestOptions = {
                            method: 'POST',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        fetch(`${config.campay.urlToCampay}/api/token/`, requestOptions).then(response => response.text()).then(result => {
                            console.log("Retour etape 1", JSON.stringify(result));
                            setvaltoken(JSON.parse(result).token);
                            let valtokent = JSON.parse(result).token;

                            var myHeaders2 = new Headers();
                            myHeaders2.append("Content-Type", "application/x-www-form-urlencoded");
                            myHeaders2.append("Authorization", "Token " + valtokent);

                            var urlencoded2 = new URLSearchParams();
                            urlencoded2.append("amount", abonnement["pprix"]);
                            urlencoded2.append("from", "237" + numtel);
                            urlencoded2.append("description", "Achat de l'abonnement "+ abonnement["pack"] +" publicitaire Yconnekt " + abonnement["pduree"] + " à " + abonnement["pprix"] + " XAF");
                            urlencoded2.append("external_reference", idopin);

                            console.log(`urlencode2: ${urlencoded2}`)
                            var requestOptions2 = {
                                method: 'POST',
                                headers: myHeaders2,
                                body: urlencoded2,
                                redirect: 'follow'
                            };

                            fetch(`${config.campay.urlToCampay}/api/collect/`, requestOptions2).then(response => response.text()).then(result => {
                                console.log("Retour etape 2", result);
                                let camref = JSON.parse(result).reference;
                                let operator = JSON.parse(result).operator;

                                var myHeaders3 = new Headers();
                                myHeaders3.append("Content-Type", "application/x-www-form-urlencoded");
                                myHeaders3.append("token", config.app.PUBLICKEY);
                                myHeaders3.append("apikey", user.token);
                                myHeaders3.append("cpte", user.code);
                                myHeaders3.append("prof", user.profil);
                                myHeaders3.append("conn", user.espace);

                                var urlencoded3 = new URLSearchParams();
                                // urlencoded3.append("code", codetransaction);
                                urlencoded3.append("refint", camref);
                                urlencoded3.append("operateur", operator);
                                urlencoded3.append("etat", 2);
                                urlencoded3.append("etatdef", "En cours");

                                var requestOptions3 = {
                                    method: 'PATCH',
                                    headers: myHeaders3,
                                    body: urlencoded3,
                                    redirect: 'follow'
                                };

                                fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions/${codetr}`, requestOptions3).then((response) => {
                                    console.log("Retour etape 3", response);
                                    if (response?.status === 205) {
                                        // textloader.setAttribute("data-text", "Payement en attente de confirmation...");
                                        startInterval(codetr, valtokent);
                                    } else if (response?.status === 200) {
                                        response.json().then(async (data) => {
                                            console.log("erreur: ", data?.body?.data?.msg);
                                            showErrorMessage(data?.body?.data?.msg);
                                            setinpayment(false);
                                        });
                                    } else {
                                        console.log(`Service indisponible`);
                                        showErrorMessage("Service indisponible! veuillez reessayer plutard.");
                                        setinpayment(false);
                                    }


                                    // fetch(`${urlMetiier}/transactions`, requestOptions3)
                                    //     .then(response => response.text())
                                    //     .then(result => {
                                    //         console.log("Retour etape 3", result);
                                    //         let body = JSON.parse(result);

                                    //         if (body?.data.head) {

                                    //             // textloader.innerText = "Payement en attente de confirmation...";
                                    //             textloader.setAttribute("data-text", "Payement en attente de confirmation...");
                                    //             startInterval(codetransaction, valtoken);


                                    //         } else {
                                    //             console.log(`Problème lors du traitement de votre transaction`);
                                    //             showErrorMessage("Problème lors du traitement du payement! veuillez reessayer plutard.")
                                    //         }


                                    //     })
                                    //     .catch(error => {
                                    //         console.log('error', error);
                                    //         showErrorMessage("Problème lors du traitement du payement! veuillez reessayer plutard.")
                                    //     });


                                }).catch(error => {
                                    console.log('error', error);
                                    showErrorMessage("Problème lors du traitement du payement! veuillez reessayer plutard.")
                                    setinpayment(false);
                                });
                            })
                        });
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    };

    const startInterval = async (code, token) => {
        console.log("first intervId: ", intervId);
        intervId = setInterval(async () => {

            try {
                settextloader("Vérification du payement...");
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                myHeaders.append("token", config.app.PUBLICKEY);
                myHeaders.append("apikey", user.token);
                myHeaders.append("cpte", user.code);
                myHeaders.append("prof", user.profil);
                myHeaders.append("conn", user.espace);

                var requestOptions = {
                    method: 'GET',
                    headers: myHeaders,
                    // body: urlencoded,
                    redirect: 'follow'
                };

                // console.log("data send", urlencoded)

                await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions/${code}`, requestOptions).then((response) => {
                    if (response?.status === 200) {
                        response.json().then(async (data) => {
                            // console.log("resonse jsondecode", data?.body?.data);
                            if (data?.head) {
                                let body = data?.body?.data[0];
                                if (body?.etat === 3) {
                                    console.log(`transaction non confirmé`);
                                    // stop interval
                                    stopInterval();
                                    showErrorMessage("Echec de l'achat de l'abonnement");
                                } else if (body?.etat === 4) {
                                    console.log('paymement effectué');
                                    stopInterval();
                                    // handleSubmit();
                                    // showSuccessMessage("Achat de l'abonnement réussi! Vous allez recevoir un SMS de confirmation contenant vos identifiants de connexion.");
                                } else if (body?.etat === 2) {
                                    let refint = body?.refint;

                                    var myHeaders2 = new Headers();
                                    myHeaders2.append("Content-Type", "application/x-www-form-urlencoded");
                                    myHeaders2.append("Authorization", "Token " + token);

                                    var requestOptions2 = {
                                        method: 'GET',
                                        headers: myHeaders2,
                                        redirect: 'follow'
                                    };

                                    fetch(`${config.campay.urlToCampay}/api/transaction/${refint}/`, requestOptions2)
                                        .then(response => response.text())
                                        .then(result => {
                                            console.log("Boucle 2 campay", result)
                                            let body = JSON.parse(result);

                                            if (body.status === "SUCCESSFUL") {
                                                stopInterval();
                                                lastUpdate(code, body.code, body.operator_reference, 4, "Réussie");
                                            } else if (body.status === "FAILED") {
                                                stopInterval();
                                                lastUpdate(code, body.code, body.operator_reference, 3, "Echec");
                                            }

                                        })
                                        .catch(error => {
                                            console.log('error', error);
                                            stopInterval();
                                        });

                                }

                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        });
                    } else {
                        console.log('Erreur de confirmation');
                        stopInterval();
                    }

                }).catch((err) => {
                    console.log('error', err);
                    stopInterval();
                });

            } catch (error) {
                console.log(`try cash error: ${error}`)
            }
            console.log("second intervId: ", intervId);

        }, 10000);
        // setintervId(pintervId);
    }

    function stopInterval() {
        // timerzone.setAttribute("style", "display: none;");
        clearInterval(intervId);
        clearInterval(timerID);
        intervId = null;
        timerID = null;
        // countDownTime = defaultValue;
    }

    const lastUpdate = async (code, codeint, refop, etat, etatdef) => {
        settextloader("Achèvement du payement...");
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        // urlencoded.append("code", code);
        urlencoded.append("codeint", codeint);
        urlencoded.append("refop", refop);
        urlencoded.append("etat", etat);
        urlencoded.append("etatdef", etatdef);
        urlencoded.append("coderevendeur", user?.codeutilisateur);
        urlencoded.append("type", "abonnement");
        

        var requestOptions3 = {
            method: 'PATCH',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions/${code}`, requestOptions3).then((response) => {
            console.log("Last update result", response);
            if (response?.status === 205) {
                stopInterval();
                if (etat === 4) {
                    console.log(`transaction terminé réussi`);
                    showSuccesMessage(textes.fr.souscriptionaddedlabel);
                    setAddstate(false);
                    setinpayment(false);
                    getElementsList(page);
                    setabonnement("");
                    setnumtel("");
                    setnoms("");
                    setFetching(false);
                    // handleSubmit();
                    // showSuccessMessage("Achat de l'abonnement réussi! Vous allez recevoir un SMS de confirmation contenant vos identifiants de connexion.");
                }

                if (etat === 3) {
                    console.log(`transaction terminé echec`);
                    setinpayment(false);
                    showErrorMessage("Echec de l'achat de l'abonnement");
                }

                // loader.setAttribute("style", "display: none;");
            } else if (response?.status === 200) {
                response.json().then(async (data) => {
                    stopInterval();
                    console.log(`Echec de mise à jour de la ref op`);
                    // loader.setAttribute("style", "display: none;")
                    console.log("erreur: ", data?.body?.data?.msg);
                    showErrorMessage("erreur: " + data?.body?.data?.msg);
                    setinpayment(false);

                });
            } else {
                setinpayment(false);
                console.log(`Service indisponible`);
                showErrorMessage("Service indisponible! veuillez reessayer plutard.");
            }

        }).catch(error => {
            stopInterval();
            console.log('error', error);
            setinpayment(false);
            // loader.setAttribute("style", "display: none;");
        });
    }


    // affichages
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && inpayment && <InPayement text={textloader} />}
                {!loading && !error && !inpayment && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <Search
                                    chaine={chaine}
                                    setChaine={setChaine}
                                    // search={searchEmployee}
                                    placeholder="Rechercher..."
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        {!addstate && (
                                            <button
                                                data-toggle="tooltip"
                                                title={textes.fr.newsouscriptionlabel}
                                                onClick={() => setAddstate(true)}
                                                data-placement="left"
                                                className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            >
                                                <i className="fa fa-plus mr-1"></i>{" "}
                                                <span>{textes.fr.newsouscriptionlabel}</span>
                                            </button>
                                        )}
                                        <h6 className="m-0 ">
                                            {addstate
                                                ? textes.fr.souscriptioninfoslabel
                                                : textes.fr.listsouscriptionlabel}
                                        </h6>
                                    </div>
                                    {!addstate && <div className="card-body">
                                        <div className="table-responsive mb-3">
                                            <table className="mb-0 table table-bordered">
                                                <thead className="bg-primary">
                                                    <tr className="bg-primary text-white">
                                                        <th className="text-center">#</th>
                                                        <th>Abonnement</th>
                                                        <th>Durée</th>
                                                        <th>Date début</th>
                                                        <th>Date fin</th>
                                                        <th>{textes.fr.statelabel}</th>
                                                        <th>{textes.fr.addeddatelabel}</th>
                                                        <th className="text-center">
                                                            {textes.fr.actionlabel}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {elementsList.length === 0 && (
                                                        <tr style={{ borderStyle: "none" }}>
                                                            <th colSpan={8} className="text-center">
                                                                {textes.fr.noabonnementfound}
                                                            </th>
                                                        </tr>
                                                    )}
                                                    {elementsList.length > 0 &&
                                                        elementsList?.map((item, index) => (
                                                            <MySous
                                                                sous={item}
                                                                position={(config.app.limit * page) + index}
                                                                key={index}
                                                            />
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <Pagination
                                            nbpage={nbpage}
                                            getList={getElementsList}
                                            page={page}
                                            setPage={setPage}
                                        />
                                    </div>}
                                    {addstate && (
                                        <div className="card-body">
                                            <form style={{ width: "100%" }} onSubmit={handlePay}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-12 mb-3">
                                                                <label htmlFor="abonnement" className="mb-1">
                                                                    {textes.fr.abonnementlabel}
                                                                </label>
                                                                <Select
                                                                    id="abonnement"
                                                                    name="abonnement"
                                                                    placeholder={textes.fr.selectlabel}
                                                                    options={abonnementsList}
                                                                    value={abonnement}
                                                                    onChange={(selected) => {
                                                                        setabonnement(selected);

                                                                    }}
                                                                    isClearable
                                                                />
                                                            </div>
                                                            <div className="col-md-12 mt-3 mb-2">
                                                                <h5 className="text-primary">Information de paiement</h5>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="numtel" className="mb-1">Numéro de téléphone OM / MOMO</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="numtel"><PhoneFill /></span>
                                                                    <input
                                                                        type="tel"
                                                                        className="form-control"
                                                                        placeholder="Entrez le numéro de téléphone"
                                                                        value={numtel}
                                                                        onChange={(e) =>
                                                                            setnumtel(e.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="noms" className="mb-1">Noms</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="noms"><Person /></span>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Entrez le nom"
                                                                        value={noms}
                                                                        onChange={(e) =>
                                                                            setnoms(e.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.newpublicitelabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                            disabled={
                                                                abonnement["value"] && numtel && noms
                                                                    ? false
                                                                    : true
                                                            }
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Valider</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setAddstate(false);
                                                                getElementsList(page);
                                                                setabonnement("");
                                                                setnumtel("");
                                                                setnoms("");
                                                            }}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
